import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { useState } from 'react';

const testimonials = [
  {
    id: 1,
    name: 'Lindsey H.',
    role: 'Emery/Weiner School parent',
    image: '/uni/houstonSchool.png',
    quote:
      'Mason has been working with my 11th grader for the past year. He has provided immeasurable support in both math and science. He has enhanced my son`s understanding of difficult concepts. Additionally, he spends time with my son on organizational and executive functioning issues such as looking ahead at the work week to plan test study, essay draft completion, and project prep. Mason`s effectiveness as an academic mentor comes through by way of improved grades and self-confidence in my son. Lastly, Mason is a trained ACT tutor, and he approaches that role with the same personalization he delivers in his academic tutoring. If you are looking for a patient, accomplished, and goal-oriented tutor, please contact Mason.',
  },
  {
    id: 2,
    name: 'Daniela C.',
    role: 'UT student',
    image: '/images/testimonials/contact-man.png',
    quote:
      'Mason is such a great tutor! Since tutoring with him, my grade has improved by a whole letter grade in my college level class! He tailors the session we have based on what I need additional instruction on. Highly recommend him!',
  },
  {
    id: 3,
    name: 'Gemma J.',
    role: 'St. Agnes Academy parent',
    image: '/images/testimonials/contact-test.png',
    quote:
      'My daughter has greatly benefitted from Mason`s tutoring sessions. He is skilled in all subjects and has a tutoring style that makes it easy for the student to connect to him. He is punctual , responsible and very well mannered. I 100% recommend him as a tutor.',
  },
  {
    id: 4,
    name: 'Daniel H.',
    role: 'Emery/Weiner School student',
    image: '/images/testimonials/contact-man.png',
    quote:
      'Excellent website, very smooth and personable. Love the feature that allows you to study in a way that is of interest to you. For example, I love sports, so if I ask for help with my calculus, it`ll give examples with sports.',
  },
  {
    id: 5,
    name: 'Winifred R.',
    role: 'St. John`s School parent',
    image: '/images/testimonials/contact-test.png',
    quote:
      'John was incredibly helpful to my son in both teaching him the nuances of the language and lessening his anxiety in speaking.',
  },
];

export default function ContactTestimonialCarousel({ showTitle = true }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const next = () => {
    setCurrentIndex((prevIndex) => (prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1));
  };

  const previous = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1));
  };

  return (
    <div className="!mx-auto w-full p-6 lg:!mt-20 lg:!px-4 lg:!py-12">
      {showTitle && (
        <h2 className="fredokaOne mx-auto max-w-[606px] text-center text-[32px] font-normal leading-normal  tracking-[-0.64px] text-[#012E33] md:text-[40px] md:tracking-[-0.8px]">
          Trusted by parents and loved by students
        </h2>
      )}
      <div className="relative">
        <div className="">
          <div>
            <div className="relative mx-auto flex max-w-[900px] flex-col rounded-2xl py-4 lg:flex-row lg:items-center lg:gap-8 lg:p-8">
              <div className="mx-auto w-[90%] sm:w-[60%] lg:m-0 lg:w-[400px]">
                <img
                  src={testimonials[currentIndex].image}
                  alt=""
                  className="aspect-square w-full rounded-xl object-cover"
                />
              </div>

              <div className="mx-auto -mt-12 w-[90%]  max-w-lg rounded-[24px] bg-white p-4 shadow-[0px_4px_4px_0px_rgba(0,0,0,0.08)] sm:w-[60%] lg:absolute lg:-right-4 lg:top-16 lg:mt-0 lg:w-2/3">
                <blockquote className="font-[Fredoka] text-[22px] font-medium leading-normal tracking-[-0.64px] text-[#012E33] lg:text-[32px]">
                  {testimonials[currentIndex].quote.substring(0, 100)}...
                </blockquote>
                <div>
                  <p className="font-[Fredoka] text-[22px] font-normal leading-[32px] tracking-[-0.22px] text-[#012E33]">
                    {testimonials[currentIndex].name}
                  </p>
                  <p className="font-[Fredoka] text-[18px] font-normal leading-normal tracking-[-0.18px] text-[#678285]">
                    {testimonials[currentIndex].role}
                  </p>
                </div>
              </div>
              <div className="mx-auto mt-6 flex justify-start gap-4 lg:mx-0 lg:-mt-2 lg:self-end">
                <button
                  onClick={previous}
                  className="w-[50px] rounded-full border border-gray-300 p-2 transition-colors hover:bg-gray-100"
                  aria-label="Previous testimonial"
                >
                  <ChevronLeft className="h-5 w-5" />
                </button>
                <button
                  onClick={next}
                  className="w-[50px] rounded-full border border-gray-300 p-2 transition-colors hover:bg-gray-100"
                  aria-label="Next testimonial"
                >
                  <ChevronRight className="h-5 w-5" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
